import axiosInstance from 'utils/axiosInterceptors';
import { bumpImageRevision } from 'utils/imageRevisions';

export const fetchImageBlobUrl = async (googleFileId: string) => {
  const res = await axiosInstance.get(`/api/v1/images/${googleFileId}`, {
    responseType: 'blob',
    params: { t: Date.now() },
    headers: { 'Cache-Control': 'no-cache' }
  });
  return URL.createObjectURL(res.data);
};

export const saveImageRotation = async (
  googleFileId: string,
  clockwiseDegrees: number
) => {
  await axiosInstance.put(`/api/v1/images/${googleFileId}/rotate`, {
    clockwiseDegrees
  });
  bumpImageRevision(googleFileId);
};
